import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;


export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
  font: var(--body);
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  text-align: justify;
  font: var(--body);
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  flex-wrap: nowrap;
  font: var(--title);
  width: 100%;
  padding: 2rem 0 1rem 0;
`;

export const DivButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 1rem;
`;

export const DivImages = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  /* flex-wrap: nowrap; */
  gap: 1rem;
  padding: 1rem;
`;

export const Images = styled.img`
  width: 22%;
`
